<div class="card-b" (click)="navigateToMediaKit()">
  <button *ngIf="removable" class="remove-btn" type="button" title="Remove from list" (click)="onRemoveClick($event)">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="#e03030" stroke="#ffffff" stroke-width="2">
      <circle cx="12" cy="12" r="11" stroke="none"/>
      <line x1="8" y1="8" x2="16" y2="16"/>
      <line x1="16" y1="8" x2="8" y2="16"/>
    </svg>
  </button>
  <div class="images" [class.single-image]="secondaryImageFailed">
    <img [src]="primaryImageSrc" [alt]="roster.name || ''" (error)="onImageError($event)">
    <img [src]="secondaryImageSrc" [alt]="roster.name || ''" (error)="onSecondaryImageError($event)">
    <div class="scrim"></div>
    <div class="overlay-name">{{ roster.name }}</div>
  </div>
  <div class="body">
    <div class="handles">{{ handlesLine }}</div>
    <div class="genre-tags" *ngIf="genreTags.length > 0">
      <span class="genre-pill" [ngClass]="genreColorClass(tag)" *ngFor="let tag of genreTags">{{ tag }}</span>
    </div>
    <div class="bio" *ngIf="roster.bioTextShort">{{ roster.bioTextShort }}</div>
    <div class="stats" [style.grid-template-columns]="'repeat(' + statColumns + ', 1fr)'">
      <div class="stat-block stat-ig" *ngIf="roster.instagramFollowers">
        <div class="snum">{{ formatFollowers(roster.instagramFollowers) }}</div>
        <div class="slabel">Instagram</div>
      </div>
      <div class="stat-block stat-tt" *ngIf="roster.tikTokFollowers">
        <div class="snum">{{ formatFollowers(roster.tikTokFollowers) }}</div>
        <div class="slabel">TikTok</div>
      </div>
      <div class="stat-block stat-yt" *ngIf="roster.youtubeFollowers">
        <div class="snum">{{ formatFollowers(roster.youtubeFollowers) }}</div>
        <div class="slabel">YouTube</div>
      </div>
    </div>
    <div class="location" *ngIf="roster.city">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" stroke-width="2.5">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
        <circle cx="12" cy="9" r="2.5"/>
      </svg>
      {{ roster.city }}<span *ngIf="roster.state">, {{ roster.state }}</span>
    </div>
  </div>
</div>
